import React from 'react';
import { Controller, Control, FieldValues } from 'react-hook-form';
import { SxProps, Theme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectProps } from '@mui/material/Select';
import Chip from '@mui/material/Chip';

interface GlobalChipMultiSelectProps {
  id: string;
  name: string;
  control: Control<FieldValues>;
  label?: string;
  options: string[];
  sx?: SxProps<Theme>;
}

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
} as const;

// Accessibility: label or aria-label is required for all chip multi-selects for screen reader support.
export const GlobalChipMultiSelect: React.FC<GlobalChipMultiSelectProps> = (props) => {
  const { id, name, control, label, options, sx } = props;

  return (
    <Controller
      name={name}
      control={control}
      render={({
        field: { onChange, value }
      }) => (
        <FormControl sx={sx}>
          <InputLabel id="multiple-chip-label">{label}</InputLabel>
          <Select
            labelId="multiple-chip-label"
            id={id}
            multiple
            value={value}
            onChange={onChange}
            input={<OutlinedInput id="multiple-chip" label={label} />}
            renderValue={(selected: string[]) => (
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                {selected.map((sValue) => (
                  <Chip key={sValue} label={sValue} />
                ))}
              </Box>
            )}
            MenuProps={MenuProps}
          >
            {options.map((option) => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}
    />
  );
}; 